<div class="icon" [inlineSVG]="'assets/icon/custom/' + icon" [removeSVGAttributes]="['fill']" [setSVGAttributes]="attr"></div>